var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bd-aside"}},[_c('div',[_vm._v("我的问卷")]),_c('div',[_vm._v("创建问卷")])])}]

export { render, staticRenderFns }